module.exports = __webpack_public_path__ + "img/5-3.8afd0f72.svg";